import { render, staticRenderFns } from "./PointExchange.vue?vue&type=template&id=898b4f78&scoped=true"
import script from "./PointExchange.vue?vue&type=script&lang=js"
export * from "./PointExchange.vue?vue&type=script&lang=js"
import style0 from "./PointExchange.vue?vue&type=style&index=0&id=898b4f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898b4f78",
  null
  
)

export default component.exports